export default "__VITE_ASSET__pWbwD5Xo__"